import React from 'react';
import { Layout } from '../components/common';
import { ContactFormSection } from '../components/contact';

const ContactPage: React.FC = () => {
  return (
    <Layout>
      <ContactFormSection />
    </Layout>
  );
};

export default ContactPage;